var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlashlight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M608 96H576C513.375 96 452.25 114.5 400.125 149.25L384 160H48C21.5 160 0 181.5 0 208V304C0 330.5 21.5 352 48 352H384L400.125 362.75C452.25 397.5 513.375 416 576 416H608C625.625 416 640 401.625 640 384V128C640 110.375 625.625 96 608 96ZM544 365.625C502.125 360.875 461.875 346.125 426.75 322.75L398.5 304H48V208H398.5L426.75 189.25C461.875 165.875 502.125 151.25 544 146.375V365.625ZM284 232H260C246.75 232 236 242.75 236 256C236 269.25 246.75 280 260 280H284C297.25 280 308 269.25 308 256C308 242.75 297.25 232 284 232Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlashlight);
export default __webpack_public_path__ + "static/media/flashlight.7a0f3226ba4acca56372eda855eb4f2c.svg";
export { ForwardRef as ReactComponent };